'use client';
import Accordion from '@/entities/InfoAccordion/ui/InfoAccordion';
import { IFaqItem } from '@/shared/api/getProduct/types';
import { HtmlContent } from '@/shared/ui/HtmlContent';
import { FC, useState } from 'react';
import { cvaQuestionsItems, cvaRoot } from './QuestionsItemsStyles';

interface Props {
  questions: IFaqItem[];
}

const QuestionsItems: FC<Props> = ({ questions }) => {
  const [expanded, setExpanded] = useState<false | number>(false);

  return (
    <div className={cvaRoot()}>
      <div className={cvaQuestionsItems()}>
        {questions?.length &&
          questions?.map((item, index) => (
            <Accordion
              key={item.id}
              i={index}
              header={item.question}
              expanded={expanded}
              setExpanded={setExpanded}
              forceShow={false}
            >
              <HtmlContent>{item.answer}</HtmlContent>
            </Accordion>
          ))}
      </div>
      {/* <div className={cvaShowMore()}>
        <button
          type={'button'}
          className={cvaShowMoreButton()}
        >
          Загрузить еще{' '}
          <IconPlus
            className={cvaShowMoreButtonIcon()}
          />
        </button>
      </div>
      <ReactPaginate
        breakLabel="..."
        nextLabel=""
        onPageChange={() => {}}
        pageRangeDisplayed={4}
        marginPagesDisplayed={1}
        pageCount={17}
        previousLabel={''}
        renderOnZeroPageCount={null}
        className={cvaPagination()}
        pageClassName={cvaPaginationPage()}
        pageLinkClassName={cvaPaginationLink()}
        activeLinkClassName={cvaPaginationLinkActive()}
        breakClassName={cvaPaginationBreak()}
        breakLinkClassName={cvaPaginationBreakLink()}
      /> */}
    </div>
  );
};

export default QuestionsItems;
